module.exports = __webpack_public_path__ + "img/home_profile@2x.546735de.png";